import projectsApi from "@/api/v1/projects";
import cloneDeep from "lodash.clonedeep";
import dayjs from "dayjs";

const collectRequestParams = rootState => {
  const { selectedFilters, order } = rootState.filters;
  const { itemsPerPage, pagination } = rootState.pagination;
  return {
    page: pagination.page,
    itemsPerPage,
    order,
    filters: selectedFilters
  };
};

export default {
  namespaced: true,

  state: {
    projectsList: [],
    activeProject: null,
    viewMode: localStorage.getItem("PTM-VIEW-MODE") || "list"
  },

  mutations: {
    SET_PROJECTS(state, projects) {
      state.projectsList = projects;
    },

    SET_VIEW_MODE(state, mode) {
      state.viewMode = mode;
    },

    REMOVE_PROJECTS(state) {
      state.projectsList = [];
    },

    TOGGLE_PROJECT_PINNING(state, { pin, id }) {
      const copiedProjects = cloneDeep(state.projectsList);
      const projectIndex = copiedProjects.findIndex(project => project.id === id);
      copiedProjects[projectIndex].pinned = pin;
      state.projectsList = copiedProjects;
    }
  },

  actions: {
    fetchProjects({ commit, dispatch, rootState }) {
      commit("CHANGE_LOADING_STATUS", true, { root: true });
      const params = collectRequestParams(rootState);

      projectsApi.projects
        .index(params)
        .then(response => {
          commit("SET_PROJECTS", response.data.collection);
          dispatch("pagination/setPagination", response.data.pagination, { root: true });
        })
        .finally(() => {
          commit("CHANGE_LOADING_STATUS", false, { root: true });
        });
    },

    fetchProjectsWithRequiredAction({ commit, dispatch, rootState }) {
      commit("CHANGE_LOADING_STATUS", true, { root: true });
      const params = collectRequestParams(rootState);

      projectsApi.projects
        .getProjectsWithRequiredAction(params)
        .then(response => {
          commit("SET_PROJECTS", response.data.collection);
          dispatch("pagination/setPagination", response.data.pagination, { root: true });
        })
        .finally(() => {
          commit("CHANGE_LOADING_STATUS", false, { root: true });
        });
    },

    softDeleteProject({ commit, dispatch, rootState }, id) {
      commit("CHANGE_LOADING_STATUS", true, { root: true });

      return projectsApi.projects
        .update(id, { softDeleted: true })
        .then(resp => {
          if (rootState.project.project.id === id)
            commit("project/SET_PROJECT", resp.data, { root: true });
          dispatch(
            "snackbar/showSnackbar",
            {
              message: ["Projekt przeniesiony do kosza"],
              type: "success"
            },
            { root: true }
          );
        })
        .finally(() => {
          commit("CHANGE_LOADING_STATUS", false, { root: true });
        });
    },

    bringProjectBack({ commit, dispatch, rootState }, id) {
      commit("CHANGE_LOADING_STATUS", true, { root: true });

      return projectsApi.projects
        .update(id, { softDeleted: false })
        .then(resp => {
          if (rootState.project.project.id === id)
            commit("project/SET_PROJECT", resp.data, { root: true });
          dispatch(
            "snackbar/showSnackbar",
            {
              message: ["Projekt powrócił na listę"],
              type: "success"
            },
            { root: true }
          );
        })
        .finally(() => {
          commit("CHANGE_LOADING_STATUS", false, { root: true });
        });
    },

    deleteProjectPermanently({ commit, dispatch }, id) {
      commit("CHANGE_LOADING_STATUS", true, { root: true });

      return projectsApi.projects
        .delete(id)
        .then(() => {
          dispatch(
            "snackbar/showSnackbar",
            {
              message: ["Projekt został trwale usunięty"],
              type: "success"
            },
            { root: true }
          );
        })
        .finally(() => {
          commit("CHANGE_LOADING_STATUS", false, { root: true });
        });
    },

    toggleProjectPinnig({ commit }, project) {
      commit("CHANGE_LOADING_STATUS", true, { root: true });
      const { id, pinned } = project;
      return projectsApi.projects
        .toggleProjectPinnig(id, !pinned)
        .then(() => {
          commit("TOGGLE_PROJECT_PINNING", { id, pin: !pinned });
        })
        .finally(() => {
          commit("CHANGE_LOADING_STATUS", false, { root: true });
        });
    },

    exportProjectsData({ commit, rootState }) {
      commit("CHANGE_LOADING_STATUS", true, { root: true });
      const { selectedFilters: filters } = rootState.filters;
      const date = dayjs().format("DD/MM/YYYY HH_mm");
      const download = "Lista projektów-" + date;

      projectsApi.projects
        .exportData({ filters })
        .then(resp => {
          const url = window.URL.createObjectURL(new Blob([resp.data], { type: "text/csv" }));
          const link = document.createElement("a");
          link.href = url;
          link.download = download;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .finally(() => {
          commit("CHANGE_LOADING_STATUS", false, { root: true });
        });
    },

    resetProjects({ commit, dispatch }) {
      commit("REMOVE_PROJECTS");
      dispatch("filters/clearFilters", null, { root: true });
      dispatch("filters/setSorting", "", { root: true });
      dispatch("pagination/resetPagination", null, { root: true });
    },

    setViewMode({ commit }, mode) {
      commit("SET_VIEW_MODE", mode);
      localStorage.setItem("PTM-VIEW-MODE", mode);
    }
  }
};
